export function isBase64(value: string): boolean {
  const base64Regex =
    /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;

  return base64Regex.test(value);
}

/**
 * Legacy travel-calculator `r` payloads are base64-encoded JSON objects.
 * JSON objects encoded as base64 normally start with `eyJ`.
 */
export function isBase64EncodedAffiliatePayload(value: string): boolean {
  return isBase64(value) && value.startsWith("eyJ");
}

export function decodeBase64(base64Value: string): string | null {
  try {
    const decodedValue = atob(base64Value);

    if (!decodedValue.startsWith("{")) {
      return null;
    }

    const parsedValue = JSON.parse(decodedValue) as {
      affiliate_id?: unknown;
    };

    if (
      parsedValue.affiliate_id === null ||
      parsedValue.affiliate_id === undefined
    ) {
      return null;
    }

    return String(parsedValue.affiliate_id);
  } catch {
    return null;
  }
}

export function affiliateIdToUse(
  rawAffiliateId: string | null | undefined,
): string | null | undefined {
  if (rawAffiliateId && isBase64EncodedAffiliatePayload(rawAffiliateId)) {
    return decodeBase64(rawAffiliateId) || rawAffiliateId;
  }

  return rawAffiliateId;
}
